import { Component, OnInit } from "@angular/core";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { PrintFormatsService } from "../print-formats.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { TranslateService } from "@ngx-translate/core";
import { ScreenConstants } from "src/app/constants/screenId.constants";

@Component({
  selector: "app-list-print-formats",
  templateUrl: "./list-print-formats.component.html",
  styleUrls: ["./list-print-formats.component.sass"],
})
export class ListPrintFormatsComponent implements OnInit {
  tableList = TableConstants.printsFormats;
  routing = RoutingConstants.printFormatsRouting;
  options = TableConstants.NotShowArrowUpDownNotShowFiltersAndShowLabel;
  filtersTable: string;
  filtersTableJSON;
  printFormats;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;

  constructor(
    private printFormatsService: PrintFormatsService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private translateService: TranslateService
  ) {
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      this.routing.id,
      ScreenConstants.admSistemas.listPrintFormats
    );
    this.filtersTable =
      "?" + this.filtersTableStateService.getString(this.filtersTableJSON);
  }

  ngOnInit(): void {
    this.getListPrintFormats();
  }

  getListPrintFormats() {
    this.printFormatsService.listPrintFormats(this.filtersTable).subscribe(
      (data) => {
        this.printFormats = data["content"];
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];
        if (data["content"] && data["content"].length == 0) {
          let message = this.translateService.instant(
            "messages.notFoundResutls"
          );
          this.toastrAlertService.toastrWarning(message);
          this.numPages = 1;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  filterTable(value) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = "?" + value.filterTableString;
    this.getListPrintFormats();
  }

  removeElements(ids: string[]) {
    this.printFormatsService.removePrintFormat(ids).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data["mensaje"]);
        this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
          this.routing.id,
          ScreenConstants.admSistemas.listPrintFormats
        );
        this.filtersTable =
          "?" + this.filtersTableStateService.getString(this.filtersTableJSON);
        this.getListPrintFormats();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
}
